/* Meubelhunter hoofdmenu 2026 — desktop megamenu (hover-intent) + mobiele drill-down drawer.
   Zelfstandig; neemt de hamburger van Empire over (capture-fase) zodat Empire's eigen mobiele nav nooit opent. */
(function () {
  'use strict';
  var DESKTOP = window.matchMedia('(min-width: 1024px)');
  var OPEN_DELAY = 120, CLOSE_DELAY = 180;

  /* ---------------- Desktop ---------------- */
  function initDesktop(nav) {
    var items = [].slice.call(nav.querySelectorAll('[data-mh-item]'));
    var panels = {};
    [].forEach.call(nav.querySelectorAll('[data-mh-panel]'), function (p) { panels[p.dataset.mhPanel] = p; });
    var timer = null, openIdx = null;

    function clearTimer() { if (timer) { clearTimeout(timer); timer = null; } }
    function trigger(i) { var it = items[i]; return it && it.querySelector('[data-mh-trigger]'); }

    function showSub(panel, j) {
      var rails = panel.querySelectorAll('[data-mh-sub]');
      var subs = panel.querySelectorAll('[data-mh-subpanel]');
      [].forEach.call(rails, function (r) { r.classList.toggle('is-active', r.dataset.mhSub === String(j)); });
      [].forEach.call(subs, function (s) { s.classList.toggle('is-active', s.dataset.mhSubpanel === String(j)); });
    }

    function close() {
      clearTimer();
      if (openIdx === null) return;
      var p = panels[openIdx], t = trigger(openIdx);
      if (p) p.hidden = true;
      if (t) t.setAttribute('aria-expanded', 'false');
      items[openIdx].classList.remove('is-open');
      openIdx = null;
    }

    function open(i) {
      clearTimer();
      if (!panels[i]) { close(); return; }
      if (openIdx === i) return;
      close();
      openIdx = i;
      items[i].classList.add('is-open');
      trigger(i).setAttribute('aria-expanded', 'true');
      panels[i].hidden = false;
      showSub(panels[i], 0);
    }

    items.forEach(function (it, i) {
      var t = trigger(i);
      it.addEventListener('mouseenter', function () {
        if (!DESKTOP.matches) return;
        clearTimer();
        timer = setTimeout(function () { open(i); }, OPEN_DELAY);
      });
      if (!t) {
        it.addEventListener('mouseenter', function () { clearTimer(); timer = setTimeout(close, OPEN_DELAY); });
        return;
      }
      t.addEventListener('focus', function () { if (DESKTOP.matches) open(i); });
      t.addEventListener('click', function (e) {
        if (!DESKTOP.matches) return;
        if (openIdx !== i) { e.preventDefault(); open(i); }
      });
      t.addEventListener('keydown', function (e) {
        if (e.key === ' ' || (e.key === 'Enter' && openIdx !== i)) { e.preventDefault(); openIdx === i ? close() : open(i); }
      });
    });

    nav.addEventListener('mouseleave', function () {
      if (!DESKTOP.matches) return;
      clearTimer();
      timer = setTimeout(close, CLOSE_DELAY);
    });
    nav.addEventListener('mouseenter', clearTimer);

    Object.keys(panels).forEach(function (k) {
      var p = panels[k];
      [].forEach.call(p.querySelectorAll('[data-mh-sub]'), function (r) {
        var j = r.dataset.mhSub;
        r.addEventListener('mouseenter', function () { showSub(p, j); });
        r.addEventListener('focus', function () { showSub(p, j); });
      });
    });

    nav.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openIdx !== null) {
        var t = trigger(openIdx); close(); if (t) t.focus();
      }
    });
    nav.addEventListener('focusout', function (e) {
      if (openIdx !== null && e.relatedTarget && !nav.contains(e.relatedTarget)) close();
    });
    document.addEventListener('click', function (e) { if (openIdx !== null && !nav.contains(e.target)) close(); });
    DESKTOP.addEventListener ? DESKTOP.addEventListener('change', function (m) { if (!m.matches) close(); })
                             : DESKTOP.addListener(function (m) { if (!m.matches) close(); });
  }

  /* ---------------- Mobiel ---------------- */
  function initMobile(drawer) {
    var panel = drawer.querySelector('[data-mh-drawer-panel]');
    var back = drawer.querySelector('[data-mh-back]');
    var backLabel = drawer.querySelector('[data-mh-back-label]');
    var logo = drawer.querySelector('[data-mh-root-only]');
    var footRoot = drawer.querySelector('[data-mh-foot-root]');
    var footCta = drawer.querySelector('[data-mh-foot-cta]');
    var sticky = drawer.querySelector('[data-mh-sticky]');
    var panes = drawer.querySelectorAll('[data-mh-pane]');
    var state = { open: false, depth: 0, group: null, sub: null };
    var lastFocus = null;

    function el(sel) { return drawer.querySelector(sel); }
    function showOnly(list, attr, value) {
      [].forEach.call(list, function (n) { n.hidden = n.getAttribute(attr) !== value; });
    }

    function render() {
      drawer.setAttribute('data-depth', String(state.depth));
      var atRoot = state.depth === 0;
      logo.hidden = !atRoot; back.hidden = atRoot;
      footRoot.hidden = !atRoot; footCta.hidden = atRoot;
      var g = state.group !== null ? el('[data-mh-mgroup="' + state.group + '"]') : null;
      var s = state.sub !== null ? el('[data-mh-msub="' + state.sub + '"]') : null;
      if (state.depth === 1 && g) {
        backLabel.textContent = 'Alle categorieën';
        sticky.href = g.dataset.mhUrl; sticky.textContent = 'Alle ' + g.dataset.mhLower + ' bekijken';
      } else if (state.depth === 2 && s) {
        backLabel.textContent = g ? g.dataset.mhTitle : 'Terug';
        sticky.href = s.dataset.mhUrl; sticky.textContent = 'Alle ' + s.dataset.mhLower + ' bekijken';
      }
      if (panes[state.depth]) panes[state.depth].scrollTop = 0;
    }

    function setDepth(d, push) {
      state.depth = d; render();
      if (push !== false) { try { history.pushState({ mhDrawer: d }, ''); } catch (e) {} }
    }

    function openDrawer() {
      if (state.open) return;
      state.open = true; state.depth = 0;
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('mh-drawer-open');
      render();
      try { history.pushState({ mhDrawer: 0 }, ''); } catch (e) {}
      setTimeout(function () { panel.focus(); }, 60);
      loadRecent();
    }

    function closeDrawer(fromPop) {
      if (!state.open) return;
      state.open = false;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('mh-drawer-open');
      if (!fromPop && history.state && typeof history.state.mhDrawer === 'number') {
        try { history.go(-(history.state.mhDrawer + 1)); } catch (e) {}
      }
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    /* Hamburger van Empire overnemen (capture: vóór Empire's eigen handler) */
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-menu-toggle]');
      if (!t || DESKTOP.matches) return;
      e.preventDefault(); e.stopPropagation();
      state.open ? closeDrawer() : openDrawer();
    }, true);

    [].forEach.call(drawer.querySelectorAll('[data-mh-drawer-close]'), function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); closeDrawer(); });
    });
    back.addEventListener('click', function () {
      if (state.depth > 0) { try { history.back(); } catch (e) { setDepth(state.depth - 1, false); } }
    });

    drawer.addEventListener('click', function (e) {
      var g = e.target.closest && e.target.closest('[data-mh-open-group]');
      if (g) {
        e.preventDefault();
        state.group = g.dataset.mhOpenGroup; state.sub = null;
        showOnly(drawer.querySelectorAll('[data-mh-mgroup]'), 'data-mh-mgroup', state.group);
        setDepth(1);
        return;
      }
      var s = e.target.closest && e.target.closest('[data-mh-open-sub]');
      if (s) {
        e.preventDefault();
        state.sub = s.dataset.mhOpenSub;
        showOnly(drawer.querySelectorAll('[data-mh-msub]'), 'data-mh-msub', state.sub);
        setDepth(2);
      }
    });

    window.addEventListener('popstate', function () {
      if (!state.open) return;
      var st = history.state;
      if (st && typeof st.mhDrawer === 'number') { state.depth = st.mhDrawer; render(); }
      else { closeDrawer(true); }
    });

    /* Escape + focus-trap */
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); closeDrawer(); return; }
      if (e.key !== 'Tab') return;
      var f = [].filter.call(panel.querySelectorAll('a[href], button, input, [tabindex]:not([tabindex="-1"])'), function (n) {
        return !n.hidden && n.offsetParent !== null && !n.closest('[hidden]');
      });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    /* Swipe naar links sluit */
    var tx = null, ty = null;
    panel.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; ty = e.touches[0].clientY; }, { passive: true });
    panel.addEventListener('touchend', function (e) {
      if (tx === null) return;
      var dx = e.changedTouches[0].clientX - tx, dy = Math.abs(e.changedTouches[0].clientY - ty);
      if (dx < -70 && dy < 60) closeDrawer();
      tx = ty = null;
    }, { passive: true });

    DESKTOP.addEventListener ? DESKTOP.addEventListener('change', function (m) { if (m.matches) closeDrawer(); })
                             : DESKTOP.addListener(function (m) { if (m.matches) closeDrawer(); });

    /* "Verder waar je was": laatst bekeken product uit Empire's recently-viewed opslag */
    var recentLoaded = false;
    function loadRecent() {
      if (recentLoaded) return; recentLoaded = true;
      var card = el('[data-mh-recent]'); if (!card) return;
      try {
        var handle = null, best = 0;
        for (var i = 0; i < localStorage.length; i++) {
          var k = localStorage.key(i);
          if (!/recentlyViewed/i.test(k)) continue;
          var arr = JSON.parse(localStorage.getItem(k));
          if (!Array.isArray(arr)) continue;
          arr.forEach(function (p) { if (p && p.handle && (p.timestamp || 0) >= best) { best = p.timestamp || 0; handle = p.handle; } });
        }
        if (!handle) return;
        fetch('/products/' + handle + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
          if (!p || !p.available) return;
          card.href = p.url;
          el('[data-mh-recent-title]').textContent = p.title;
          el('[data-mh-recent-price]').textContent = formatPrice(p.price);
          var img = el('[data-mh-recent-img]');
          if (p.featured_image) { img.src = p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_96x96$1$2'); } else { img.remove(); }
          card.hidden = false;
        }).catch(function () {});
      } catch (e) {}
    }
    function formatPrice(cents) {
      var e = Math.floor(cents / 100), r = cents % 100;
      var s = String(e).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return s + (r === 0 ? ',-' : ',' + (r < 10 ? '0' + r : r));
    }
  }

  function init() {
    var nav = document.querySelector('[data-mh-nav]');
    var drawer = document.querySelector('[data-mh-drawer]');
    if (nav) initDesktop(nav);
    if (drawer) {
      /* Uit de header halen: die vormt een stacking context (z-index 1100) waardoor de drawer anders
         onder app-widgets (WhatsApp-knop, Klaviyo) blijft hangen. */
      if (drawer.parentElement !== document.body) document.body.appendChild(drawer);
      initMobile(drawer);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
